export enum MassMailType {
  Aptauja = 'aptauja',
  Marketing = 'mārketings',
}
